export const UA_THEME_VARS = 'ua-variables' as const;
export const UA_THEME_VARS_DARK = 'ua-variables-dark' as const;
export const INTERFACE_THEME = 'interface-theme' as const;
export const PLATFORM_SHELL_CLASSNAME = 'is-platform-shell' as const;
export const UA_INTERFACE_ENABLE_HOVER_EFFECT = 'ua_interface_enable_hover_effect ' as const;

/**
 * Key used to mark DOM events as handled by a no-code block.
 * When a block (e.g., IconButton, Checkbox) handles a click event,
 * it sets this property on the native event to signal that parent
 * components (e.g., Card header collapse toggle) should not also
 * react to the same event.
 */
export const UA_NOCODE_EVENT_HANDLED_KEY = '__uaNoCodeEventHandled' as const;
export const UA_NOCODE_EVENT_HANDLED_BLOCK_TYPE_KEY = '__uaNoCodeEventHandledBlockType' as const;
